module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/why-delete-my-issue-comment-54.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/faq/why-delete-my-issue-comment.md
// module id = 755
// module chunks = 180